import * as R from 'remeda';
import { Skeleton, TableCell } from '@rossum/ui/material';
import { TableRow } from './BillingTable';

type LoadingTableProps = {
  rowsCount: number;
  columnsCount: number;
};

const LoadingTable = ({ rowsCount, columnsCount }: LoadingTableProps) => (
  <>
    {R.range(0, rowsCount).map(i => (
      <TableRow key={i} className="TableRowOverride TableRowPlaceholder">
        {R.range(0, columnsCount).map(column => (
          <TableCell key={column}>
            <Skeleton />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);

export { LoadingTable };
